import React from "react";

const OverviewEP = () => {
  return (
    <div className="flex md:space-x-2">
      <div className="md:w-3/4">
        <div className="border-2 p-2 border-sdorange inline-block mb-1 ">
          <p>Course Overview</p>
        </div>

        <div>
          <img src="/image-fix/random-images/young-emerging-politician.jpg" />
        </div>
        <div id="overview">
          <p className="text-justify">
            The Young Emerging Politician Programme equips aspiring political
            leaders with advanced knowledge of governance, diplomacy, and global
            political systems. This 30-ECTS postgraduate course combines
            theoretical insights with practical applications, enabling students
            to critically evaluate policy-making processes and address
            contemporary political challenges. Participants will develop
            leadership, communication, and strategic skills essential for
            initiating impactful change in global political landscapes. The
            curriculum incorporates comparative politics, cultural diplomacy,
            and sustainable governance strategies to foster a nuanced
            understanding of diverse political systems. Graduates will be
            prepared for advanced studies in diplomacy or careers in politics,
            policy-making, and international relations.
          </p>
        </div>
      </div>
      <div className="md:w-1/4 hidden p-2 rounded-lg border-2 border-sdorange bg-sdbodywhiteywhitebody md:flex items-center">
        {" "}
        <img
          src="/image-fix/academic-programmes/executive-education/schima.png"
          className="w- w-full"
        />
      </div>
    </div>
  );
};

export default OverviewEP;
